import React from "react";
import { useMe } from "../../api/queries/users.queries";
import AssureurDashboard from "../broker-dashboard/AssureurDashboard";
import BrokerDashboard from "../broker-dashboard/BrokerDashboard";
import SyndicDashboard from "../broker-dashboard/SyndicDashboard";
import DuneDashboard from "../dune-dashboard/DuneDashboard";
import { RoleEnum } from "../../../../../packages/vars/src";

const Dashboard: React.FC = () => {
	const { me: user, isLoading } = useMe();

	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-xl font-semibold">
					Chargement du tableau de bord...
				</h1>
			</div>
		);
	}

	if (!user) {
		return (
			<div className="flex items-center justify-center h-screen">
				<h1 className="text-xl font-semibold text-red-600">
					Erreur lors du chargement des informations utilisateur
				</h1>
			</div>
		);
	}
	switch (user.role) {
		case RoleEnum.DUNE:
			return <DuneDashboard />;
		case RoleEnum.BROKER:
			return <BrokerDashboard />;
		case RoleEnum.SYNDIC:
			return <SyndicDashboard />;
		case RoleEnum.INSURER:
			return <AssureurDashboard />;
		default:
			return (
				<div className="flex items-center justify-center h-screen">
					<h1 className="text-xl font-semibold text-red-600">
						Rôle utilisateur non pris en charge : {user.role}
					</h1>
				</div>
			);
	}
};

export default Dashboard;
